import { CachedFileItem } from './CachedFileItem';
import { appendArrayBuffer } from './append/appendArrayBuffer';
import { appendFileList } from './append/appendFileList';
import { appendPath } from './append/appendPath';
import { appendText } from './append/appendText';
import { appendSource } from './append/appendSource';
import { appendWebSource } from './append/appendWebSource';
import { fromIum } from './fromIum';
import { toIum } from './toIum';
import { convertExtendedSourceToFile } from './utilities/convertExtendedSourceToFile';
import { expandAndFilter } from './utilities/expand/expandAndFilter';
import { shouldAddItem } from './utilities/shouldAddItem';
export class FileCollection {
    constructor(options = {}) {
        this.options = options;
        this.filter = options.filter || {};
        this.files = [];
        this.sources = [];
        this.cache = options.cache ?? false;
    }
    /**
     * This is unexpected to be used directly
     * @param source
     * @private
     */
    async appendExtendedSource(source) {
        if (!shouldAddItem(source.relativePath, this.filter))
            return;
        this.sources.push(source);
        const sourceFile = convertExtendedSourceToFile(source);
        const files = await expandAndFilter(sourceFile, this.options);
        for (const file of files) {
            if (this.files.some((existing) => existing.relativePath === file.relativePath)) {
                throw new Error(`Duplicate relativePath: ${file.relativePath}`);
            }
            if (this.cache) {
                this.files.push(new CachedFileItem(file));
            }
            else {
                this.files.push(file);
            }
        }
    }
    appendWebSource(webSourceURL, options = {}) {
        return appendWebSource(this, webSourceURL, options);
    }
    appendFileList(fileList) {
        return appendFileList(this, fileList);
    }
    appendSource(webSource, options = {}) {
        return appendSource(this, webSource, options);
    }
    /**
     * This method can only be used from nodejs and will throw an error in the browser
     */
    appendPath(path) {
        return appendPath(this, path);
    }
    appendText(relativePath, text, options = {}) {
        return appendText(this, relativePath, text, options);
    }
    appendArrayBuffer(relativePath, arrayBuffer, options = {}) {
        return appendArrayBuffer(this, relativePath, arrayBuffer, options);
    }
    toIum(options = {}) {
        this.alphabetical();
        return toIum(this, options);
    }
    static async fromIum(ium) {
        const fileCollection = await fromIum(ium);
        fileCollection.alphabetical();
        return fileCollection;
    }
    alphabetical() {
        this.sources.sort((a, b) => a.relativePath < b.relativePath ? -1 : 1);
        this.files.sort((a, b) => a.relativePath < b.relativePath ? -1 : 1);
    }
    [Symbol.iterator]() {
        return this.files.values();
    }
}
//# sourceMappingURL=FileCollection.js.map